const COUNTRY_CONTACT_CONFIG = {
    US: {
        timeZone: 'America/New_York',
        weekdayStart: 8 * 60,
        weekdayEnd: 22 * 60,
        weekendStart: 11 * 60,
        weekendEnd: 22 * 60
    },
    UK: {
        timeZone: 'Europe/London',
        weekdayStart: 9 * 60,
        weekdayEnd: 17 * 60,
        weekendStart: 9 * 60,
        weekendEnd: 17 * 60
    },
    AU: {
        timeZone: 'Australia/Sydney',
        weekdayStart: 9 * 60,
        weekdayEnd: 17 * 60 + 30,
        weekendStart: 9 * 60,
        weekendEnd: 17 * 60
    },
    DE: {
        timeZone: 'Europe/Berlin',
        weekdayStart: 9 * 60,
        weekdayEnd: 18 * 60,
        weekendStart: 10 * 60,
        weekendEnd: 16 * 60
    }
}

if (!customElements.get('ly-main-product-form-contact-us')) {
    customElements.define('ly-main-product-form-contact-us', class extends HTMLElement {
        connectedCallback() {
            const country = this.dataset.country || 'US'
            this.config = COUNTRY_CONTACT_CONFIG[country] || COUNTRY_CONTACT_CONFIG.US

            this.formatter = new Intl.DateTimeFormat('en-US', {
                timeZone: this.config.timeZone,
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                hour12: false
            })

            this.update()

            this.timer = setInterval(() => {
                this.update()
            }, 10 * 60_000)
        }

        disconnectedCallback() {
            if (this.timer) {
                clearInterval(this.timer)
                this.timer = null
            }
        }

        update = () => {
            this.classList.toggle('is-working', this.isWorkingTime())
        }

        getLocalDate = () => {
            const parts = this.formatter.formatToParts(new Date())

            const values = Object.fromEntries(
                parts
                    .filter(part => part.type !== 'literal')
                    .map(part => [part.type, part.value])
            )

            return new Date(
                Number(values.year),
                Number(values.month) - 1,
                Number(values.day),
                Number(values.hour),
                Number(values.minute)
            )
        }

        isWorkingTime = () => {
            const localDate = this.getLocalDate()

            const totalMinutes = localDate.getHours() * 60 + localDate.getMinutes()
            const day = localDate.getDay()

            const isWeekend = day === 0 || day === 6

            const start = isWeekend ? this.config.weekendStart : this.config.weekdayStart
            const end = isWeekend ? this.config.weekendEnd : this.config.weekdayEnd

            return totalMinutes >= start && totalMinutes < end
        }
    })
}